import BaseComponent from '../../components/base-component/base-component'
import Carousel from '../carousel/carousel'

class ProductMediaCarousel extends BaseComponent {
  carouselSelector: string

  constructor() {
    super()

    this.carouselSelector = `[data-product-media-carousel-component]`
  }

  connectedCallback(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(variant, isForceAnimation = false): void {
    const carousel = this.querySelector<Carousel>(this.carouselSelector)

    if (variant && variant.featured_media && carousel) {
      const slides = carousel.embla.slideNodes()
      const targetIndex = slides.findIndex(slide => {
        if (!slide.dataset.mediaId) {
          return false
        }

        return +slide.dataset.mediaId === +variant.featured_media.id
      })

      carousel.embla.scrollTo(targetIndex, isForceAnimation)
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}

export default ProductMediaCarousel
